import { FC } from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { AIBadge } from 'ui/badge';
import { heading3 } from 'ui/theme';

export const ColorText = styled.h3`
  ${heading3};
  margin-top: ${pxToRem(20)};
  background: linear-gradient(
    242.03deg,
    #ff4d80 6.53%,
    #fe4d81 11.5%,
    #fc4e82 16.47%,
    #f95086 21.44%,
    #f4528a 26.41%,
    #ee5490 31.38%,
    #e65897 36.35%,
    #de5b9f 41.31%,
    #d65fa7 46.28%,
    #ce62af 51.25%,
    #c666b6 56.22%,
    #c068bc 61.19%,
    #bb6ac0 66.16%,
    #b86cc4 71.13%,
    #b66dc5 76.1%,
    #b56dc6 81.07%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  /* stylelint-disable */
  text-fill-color: transparent;
`;

const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 2.5px;
`;

export const XAIHeader: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <HeaderRow>
      <AIBadge />
      <ColorText>{children}</ColorText>
    </HeaderRow>
  );
};
